import {ReactNode} from "react";

import {Highlight} from "@pg-design/text-module";

export enum AuthModalVariant {
    DEFAULT,
    FAVORITE,
    HIDDEN_PRICES,
    DOWNLOAD_REPORT,
    HIDDEN_PRICES_VARIANT_B,
    PRICE_HISTORY,
    CONSTRUCTION_PHOTOS,
    PROPERTY_PLAN_DOWNLOAD,
    PROMOTION_LEAD,
    NOTIFICATION_SUBSCRIPTION,
    PROPERTY_FAQ,
    FREE_RESERVATION
}

export interface IAuthModalHeaderContent {
    title: ReactNode;
    description: ReactNode;
    // shown under the title of the registration flow modal as well - the other descriptions are written for the auth modal only
    registrationFlowDescription?: ReactNode;
}

const FREE_RESERVATION_DESCRIPTION =
    "Bezpłatna, niezobowiązująca rezerwacja mieszkania na 24 godziny — deweloper skontaktuje się z Tobą, aby umówić spotkanie.";

export const getAuthModalHeaderContent = (variant: AuthModalVariant): IAuthModalHeaderContent => {
    switch (variant) {
        case AuthModalVariant.FAVORITE:
            return {
                title: (
                    <>
                        Załóż konto, aby <Highlight>zapisywać ulubione oferty</Highlight>
                    </>
                ),
                description: "Dodaj mieszkania do ulubionych, porównuj oferty i otrzymuj najważniejsze informacje o cenach i promocjach."
            };

        case AuthModalVariant.HIDDEN_PRICES:
            return {
                title: (
                    <>
                        Załóż konto, aby <Highlight>odkryć ceny</Highlight>
                    </>
                ),
                description: "Dodaj mieszkania do ulubionych, porównuj oferty i otrzymuj najważniejsze informacje o cenach i promocjach"
            };

        case AuthModalVariant.DOWNLOAD_REPORT:
            return {
                title: (
                    <>
                        Załóż konto i <Highlight>zobacz raport o deweloperze</Highlight>
                    </>
                ),
                description: "Uzyskaj dostęp do widocznych cen oraz wielu innych funkcji na portalu"
            };

        case AuthModalVariant.HIDDEN_PRICES_VARIANT_B:
            return {
                title: (
                    <>
                        Załóż konto i <Highlight>odkryj ceny</Highlight> wszystkich mieszkań na portalu
                    </>
                ),
                description: "Dodaj mieszkania do ulubionych, porównuj oferty i otrzymuj najważniejsze informacje o cenach i promocjach"
            };

        case AuthModalVariant.PRICE_HISTORY:
            return {
                title: (
                    <>
                        Załóż konto i <Highlight>odkryj historie cen</Highlight> dla wszystkich mieszkań na portalu
                    </>
                ),
                description: "Dodaj mieszkania do ulubionych, porównuj oferty i otrzymuj najważniejsze informacje o cenach i promocjach"
            };
        case AuthModalVariant.CONSTRUCTION_PHOTOS:
            return {
                title: (
                    <>
                        Załóż konto i <Highlight>zobacz zdjęcia z budowy</Highlight>
                    </>
                ),
                description: null
            };
        case AuthModalVariant.PROPERTY_PLAN_DOWNLOAD:
            return {
                title: (
                    <>
                        Załóż konto i <Highlight>pobierz rzut</Highlight>
                    </>
                ),
                description: null
            };
        case AuthModalVariant.PROMOTION_LEAD:
            return {
                title: (
                    <>
                        Załóż konto, aby <Highlight>wysłać zapytanie o promocję</Highlight>
                    </>
                ),
                description: "Zaloguj się lub zarejestruj konto, aby dokończyć wysyłkę formularza."
            };
        case AuthModalVariant.NOTIFICATION_SUBSCRIPTION:
            return {
                title: (
                    <>
                        Załóż konto aby <Highlight>otrzymać powiadomienia</Highlight> o nowych ofertach
                    </>
                ),
                description: null
            };
        case AuthModalVariant.PROPERTY_FAQ:
            return {
                title: (
                    <>
                        Załóż konto, aby <Highlight>zobaczyć odpowiedzi</Highlight> na najczęściej zadawane pytania
                    </>
                ),
                description: null
            };
        case AuthModalVariant.FREE_RESERVATION:
            return {
                title: (
                    <>
                        Załóż konto, aby <Highlight>zarezerwować bezpłatnie</Highlight>
                    </>
                ),
                description: FREE_RESERVATION_DESCRIPTION,
                registrationFlowDescription: FREE_RESERVATION_DESCRIPTION
            };
        case AuthModalVariant.DEFAULT:
        default:
            return {
                title: null,
                description: null
            };
    }
};
import {ReactNode} from "react";

import {Highlight} from "@pg-design/text-module";

export enum AuthModalVariant {
    DEFAULT,
    FAVORITE,
    HIDDEN_PRICES,
    DOWNLOAD_REPORT,
    HIDDEN_PRICES_VARIANT_B,
    PRICE_HISTORY,
    CONSTRUCTION_PHOTOS,
    PROPERTY_PLAN_DOWNLOAD,
    PROMOTION_LEAD,
    NOTIFICATION_SUBSCRIPTION,
    PROPERTY_FAQ,
    FREE_RESERVATION
}

export interface IAuthModalHeaderContent {
    title: ReactNode;
    description: ReactNode;
    // shown under the title of the registration flow modal as well - the other descriptions are written for the auth modal only
    registrationFlowDescription?: ReactNode;
}

const FREE_RESERVATION_DESCRIPTION =
    "Bezpłatna, niezobowiązująca rezerwacja mieszkania na 24 godziny — deweloper skontaktuje się z Tobą, aby umówić spotkanie.";

export const getAuthModalHeaderContent = (variant: AuthModalVariant): IAuthModalHeaderContent => {
    switch (variant) {
        case AuthModalVariant.FAVORITE:
            return {
                title: (
                    <>
                        Załóż konto, aby <Highlight>zapisywać ulubione oferty</Highlight>
                    </>
                ),
                description: "Dodaj mieszkania do ulubionych, porównuj oferty i otrzymuj najważniejsze informacje o cenach i promocjach."
            };

        case AuthModalVariant.HIDDEN_PRICES:
            return {
                title: (
                    <>
                        Załóż konto, aby <Highlight>odkryć ceny</Highlight>
                    </>
                ),
                description: "Dodaj mieszkania do ulubionych, porównuj oferty i otrzymuj najważniejsze informacje o cenach i promocjach"
            };

        case AuthModalVariant.DOWNLOAD_REPORT:
            return {
                title: (
                    <>
                        Załóż konto i <Highlight>zobacz raport o deweloperze</Highlight>
                    </>
                ),
                description: "Uzyskaj dostęp do widocznych cen oraz wielu innych funkcji na portalu"
            };

        case AuthModalVariant.HIDDEN_PRICES_VARIANT_B:
            return {
                title: (
                    <>
                        Załóż konto i <Highlight>odkryj ceny</Highlight> wszystkich mieszkań na portalu
                    </>
                ),
                description: "Dodaj mieszkania do ulubionych, porównuj oferty i otrzymuj najważniejsze informacje o cenach i promocjach"
            };

        case AuthModalVariant.PRICE_HISTORY:
            return {
                title: (
                    <>
                        Załóż konto i <Highlight>odkryj historie cen</Highlight> dla wszystkich mieszkań na portalu
                    </>
                ),
                description: "Dodaj mieszkania do ulubionych, porównuj oferty i otrzymuj najważniejsze informacje o cenach i promocjach"
            };
        case AuthModalVariant.CONSTRUCTION_PHOTOS:
            return {
                title: (
                    <>
                        Załóż konto i <Highlight>zobacz zdjęcia z budowy</Highlight>
                    </>
                ),
                description: null
            };
        case AuthModalVariant.PROPERTY_PLAN_DOWNLOAD:
            return {
                title: (
                    <>
                        Załóż konto i <Highlight>pobierz rzut</Highlight>
                    </>
                ),
                description: null
            };
        case AuthModalVariant.PROMOTION_LEAD:
            return {
                title: (
                    <>
                        Załóż konto, aby <Highlight>wysłać zapytanie o promocję</Highlight>
                    </>
                ),
                description: "Zaloguj się lub zarejestruj konto, aby dokończyć wysyłkę formularza."
            };
        case AuthModalVariant.NOTIFICATION_SUBSCRIPTION:
            return {
                title: (
                    <>
                        Załóż konto aby <Highlight>otrzymać powiadomienia</Highlight> o nowych ofertach
                    </>
                ),
                description: null
            };
        case AuthModalVariant.PROPERTY_FAQ:
            return {
                title: (
                    <>
                        Załóż konto, aby <Highlight>zobaczyć odpowiedzi</Highlight> na najczęściej zadawane pytania
                    </>
                ),
                description: null
            };
        case AuthModalVariant.FREE_RESERVATION:
            return {
                title: (
                    <>
                        Załóż konto, aby <Highlight>zarezerwować bezpłatnie</Highlight>
                    </>
                ),
                description: FREE_RESERVATION_DESCRIPTION,
                registrationFlowDescription: FREE_RESERVATION_DESCRIPTION
            };
        case AuthModalVariant.DEFAULT:
        default:
            return {
                title: null,
                description: null
            };
    }
};
